import { useAuth0 } from '@auth0/auth0-react';
import { ServiceFacilitiesTab } from '@features/service-facilities';
import { Alert } from '@mui/material';

/**
 * Staff view of an organization's service facilities (decisions 32 and 33):
 * Moderators read, Admins create and edit, through the org-scoped staff routes.
 * admin-v2 routes are not role-gated, so other roles get a notice instead of
 * requests the staff routes would refuse. Roles come from the Auth0 claim the
 * staff guards check, and nothing renders until that session is known.
 */
export function OrganizationServiceFacilitiesTab({ organizationId }: { organizationId: string }) {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const roles: unknown = user?.['https://api.smartscribe.health/roles'];
  const canEdit = Array.isArray(roles) && roles.includes('Admin');
  const canRead = canEdit || (Array.isArray(roles) && roles.includes('Moderator'));

  // Without an org the shared tab would fall back to the staff user's own org.
  if (!organizationId || isLoading || !isAuthenticated) return null;

  if (!canRead) {
    return (
      <Alert severity="info">
        Viewing service facilities requires the Moderator or Admin role.
      </Alert>
    );
  }

  return <ServiceFacilitiesTab organizationId={organizationId} readOnly={!canEdit} />;
}
